import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import Seo from "@/components/feature/Seo";
import Breadcrumbs from "@/components/feature/Breadcrumbs";
import SubmissionForm from "./components/SubmissionForm";

const channels = [
  {
    icon: "ri-mail-send-line",
    label: "投稿与纠错",
    value: "tips@guawang30.com",
    note: "收到后 2 个工作日内给出是否更新的回复",
  },
  {
    icon: "ri-briefcase-4-line",
    label: "内容与品牌合作",
    value: "hello@guawang30.com",
    note: "请简单说明合作方向与预期形式",
  },
  {
    icon: "ri-time-line",
    label: "人工核对时间",
    value: "周一至周五 10:00 - 18:00",
    note: "周末提交的线索会顺延到下一个工作日",
  },
];

const guides = [
  { icon: "ri-calendar-check-line", title: "写清大致时间", text: "有具体日期最好，写下「某个时间段」也能帮我们定位。" },
  { icon: "ri-film-line", title: "带上作品或节目名", text: "剧名、节目名、活动名能让核对效率提高很多。" },
  { icon: "ri-links-line", title: "附上原帖链接", text: "有原始出处我们会优先处理，没有也可以照常提交。" },
  { icon: "ri-lock-line", title: "别发隐私内容", text: "涉及个人信息安全的内容不收录，也不会受理。" },
];

export default function Contact() {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      name: "联系我们｜瓜网30投稿与纠错",
      url: `${origin}/contact`,
      inLanguage: "zh-CN",
      description: "通过表单或邮箱向瓜网30提交爆料线索、内容纠错或合作咨询。",
      mainEntity: {
        "@type": "Organization",
        name: "瓜网30",
        url: `${origin}/`,
        email: "tips@guawang30.com",
        contactPoint: {
          "@type": "ContactPoint",
          contactType: "内容投稿与纠错",
          email: "tips@guawang30.com",
          availableLanguage: "zh-CN",
        },
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "首页", item: `${origin}/` },
        { "@type": "ListItem", position: 2, name: "联系我们", item: `${origin}/contact` },
      ],
    },
  ];

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Seo
        title="联系我们｜瓜网30投稿、纠错与合作"
        description="瓜网30投稿通道：提交爆料线索、指出内容错误或洽谈内容合作。填写表单即可，说明事件时间与作品名称，我们会人工核对后回复。"
        keywords="瓜网30投稿,内容纠错,联系我们,爆料投稿,娱乐线索"
        canonicalPath="/contact"
        jsonLd={jsonLd}
      />
      <SiteHeader />

      <main className="flex-1 w-full">
        <section className="w-full bg-background-100 border-b border-background-200">
          <div className="w-full px-4 md:px-8 py-8 md:py-10">
            <Breadcrumbs items={[{ label: "首页", to: "/" }, { label: "联系我们" }]} />
            <div className="mt-5 max-w-3xl">
              <p className="flex items-center gap-2 text-xs text-primary-600 mb-3">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-send-plane-line"></i>
                </span>
                CONTACT
              </p>
              <h1 className="font-heading font-black text-2xl md:text-4xl text-foreground-950">
                投稿、纠错，或者聊聊合作
              </h1>
              <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                如果你手里有一条我们漏掉的事件，或者发现某条盘点的信息有出入，
                都可以通过下面的表单告诉我们。写清楚时间和作品，剩下的交给我们核对。
              </p>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-8 py-10 md:py-12" aria-labelledby="form-title">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10">
            <div className="lg:col-span-2">
              <h2 id="form-title" className="font-heading font-black text-xl md:text-2xl text-foreground-950 mb-5">
                投稿与纠错表单
              </h2>
              <SubmissionForm />
            </div>

            <aside className="lg:col-span-1 space-y-5">
              <div className="bg-background-100 border border-background-200 rounded-lg p-5">
                <h2 className="font-heading font-bold text-base text-foreground-950 mb-4">其他联系方式</h2>
                <ul className="space-y-4">
                  {channels.map((c) => (
                    <li key={c.label} className="flex items-start gap-3">
                      <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                        <i className={`${c.icon} text-lg`}></i>
                      </span>
                      <div>
                        <p className="text-xs text-foreground-500">{c.label}</p>
                        <p className="text-sm font-medium text-foreground-950 break-all">{c.value}</p>
                        <p className="text-xs text-foreground-500 mt-1 leading-relaxed">{c.note}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="bg-accent-50 border border-accent-200 rounded-lg p-5">
                <h2 className="font-heading font-bold text-base text-foreground-950 mb-4">投稿小提示</h2>
                <ul className="space-y-4">
                  {guides.map((g) => (
                    <li key={g.title} className="flex items-start gap-3">
                      <span className="w-5 h-5 mt-0.5 shrink-0 flex items-center justify-center text-accent-700">
                        <i className={g.icon}></i>
                      </span>
                      <div>
                        <p className="text-sm font-medium text-foreground-950">{g.title}</p>
                        <p className="text-xs text-foreground-600 mt-0.5 leading-relaxed">{g.text}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="bg-primary-900 rounded-lg p-5">
                <p className="font-heading font-bold text-background-50 mb-2">还不确定要说什么？</p>
                <p className="text-sm text-primary-200 leading-relaxed mb-4">
                  先去看看完整榜单，说不定你想找的那条已经在里面了。
                </p>
                <Link
                  to="/rankings"
                  className="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-md bg-accent-500 text-primary-950 text-sm whitespace-nowrap hover:bg-accent-400 transition-colors cursor-pointer"
                >
                  查看 30 条大盘点
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </aside>
          </div>
        </section>
      </main>

      <SiteFooter />
      <BackToTop />
    </div>
  );
}